import { render, staticRenderFns } from "./CascoAjanlatAdatokB1_V0.vue?vue&type=template&id=00d835f2&"
import script from "./CascoAjanlatAdatokB1_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB1_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports